module.exports = __webpack_public_path__ + "img/Butterfly_00192.ca2866e1.png";